var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavigateRightLarge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 44C35.82184 44 45 34.82184 45 23.5S35.82184 3 24.5 3 4 12.17816 4 23.5 13.17816 44 24.5 44zm0-2C14.28273 42 6 33.71727 6 23.5S14.28273 5 24.5 5 43 13.28273 43 23.5 34.71727 42 24.5 42zm-2.51864-13.09348c-.39078.39027-.3912 1.02343-.00094 1.41421.39027.39079 1.02343.3912 1.41422.00094l6.34211-6.33373-6.35142-6.17945c-.39584-.38513-1.02895-.37644-1.41408.0194-.38512.39585-.37644 1.02895.01941 1.41408l4.89716 4.76457-4.90646 4.89998z",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigateRightLarge);
export default __webpack_public_path__ + "static/media/navigateRightLarge.f6fbab01.svg";
export { ForwardRef as ReactComponent };